import { ParsedUrlQuery } from 'querystring';

export function getPolyenc(query: ParsedUrlQuery) {
    if (query['polyenc']) {
        return query['polyenc'];
    }

    return '';
}
